import React, { lazy, Suspense } from "react";
import { Loading } from "../../components";
import { ViewPartial } from "../../cms/pages/partials/viewPartial";
const CurlSecret = lazy(() => import("./curlSecret"));

export function CurlSecretLoadingV5NZ(props) {
  return (
    <div>
      <Suspense fallback={<Loading />}>
        <CurlSecret />
      </Suspense>
      <div className='curlSecretFooter' id='curlSecretFooter'>
        <ViewPartial />
      </div>
    </div>
  );
}
